export default function FAQSection() {
  const faqs = [
    {
      q: '韩漫网上的漫画都是免费的吗？',
      a: '是的，韩漫网上所有漫画资源均免费提供在线阅读。我们致力于让每一位漫画爱好者都能畅享优质的韩国漫画内容，无需支付任何费用。',
    },
    {
      q: '韩漫网更新频率如何？',
      a: '我们保持每日更新的频率，确保读者能够在第一时间追到最新话。热门漫画通常会在韩文版更新后24小时内完成翻译上线，让您无需漫长等待。',
    },
    {
      q: '韩漫网支持哪些设备阅读？',
      a: '韩漫网全面支持电脑端、平板端和手机端阅读。我们的响应式设计可以自动适配不同屏幕尺寸，无论在哪种设备上都能获得流畅舒适的阅读体验。',
    },
    {
      q: '如果遇到加载慢或页面无法显示怎么办？',
      a: '请先检查您的网络连接。如果问题持续，可以尝试清除浏览器缓存或切换网络环境。韩漫网采用全球CDN加速，通常能保证快速稳定的访问体验。如仍有问题，欢迎联系我们的客服团队。',
    },
    {
      q: '可以在韩漫网上投稿或推荐漫画吗？',
      a: '当然可以！我们非常欢迎读者向我们推荐优质的韩国漫画。您可以通过"关于我们"页面提供的联系方式，将您想看的漫画名称发送给我们，我们会评估并尽快安排上线。',
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于韩漫网，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group border border-background-200 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h4 className="font-medium text-sm md:text-base text-foreground-800 pr-4">
                  {faq.q}
                </h4>
                <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform duration-300">
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FAQStructuredData() {
  const faqs = [
    {
      q: '韩漫网上的漫画都是免费的吗？',
      a: '是的，韩漫网上所有漫画资源均免费提供在线阅读。',
    },
    {
      q: '韩漫网更新频率如何？',
      a: '我们保持每日更新的频率，确保读者能够在第一时间追到最新话。',
    },
    {
      q: '韩漫网支持哪些设备阅读？',
      a: '韩漫网全面支持电脑端、平板端和手机端阅读。',
    },
    {
      q: '如果遇到加载慢或页面无法显示怎么办？',
      a: '请先检查您的网络连接。如仍有问题，欢迎联系我们的客服团队。',
    },
    {
      q: '可以在韩漫网上投稿或推荐漫画吗？',
      a: '当然可以！您可以通过"关于我们"页面提供的联系方式推荐优质韩国漫画。',
    },
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
}